import { DumpsterSize } from "./Order";

// Billed dump weight (tons) of a full container, keyed by dumpster size then by
// the material being disposed. Mirrors the backend `dump_weight_by_material`
// setting. Material keys are the backend's canonical set (not the free-text
// order field): construction/household/mix/other for standard sizes, and
// dirt/brick/block/concrete/other for clean fill.
export type MaterialWeights = Record<string, number>;

export type DumpWeightByMaterial = Record<DumpsterSize, MaterialWeights>;

export interface MaterialField {
  key: string;
  label: string;
}

// Standard roll-off materials (10 yd, 15 yd).
const STANDARD_MATERIALS: MaterialField[] = [
  { key: "construction", label: "Construction" },
  { key: "household", label: "Household" },
  { key: "mix", label: "Mix" },
  { key: "other", label: "Other" },
];

// Clean-fill materials.
const CLEAN_FILL_MATERIALS: MaterialField[] = [
  { key: "dirt", label: "Dirt" },
  { key: "brick", label: "Brick" },
  { key: "block", label: "Block" },
  { key: "concrete", label: "Concrete" },
  { key: "other", label: "Other" },
];

// Which materials each dumpster size carries, in editor display order. Matches
// the backend default's per-size key set so the editor round-trips exactly.
export const DUMP_WEIGHT_MATERIALS_BY_SIZE: Record<DumpsterSize, MaterialField[]> = {
  [DumpsterSize.SIZE_10]: STANDARD_MATERIALS,
  [DumpsterSize.SIZE_15]: STANDARD_MATERIALS,
  [DumpsterSize.SIZE_CLEAN_FILL]: CLEAN_FILL_MATERIALS,
};
